import { useFormContext, useWatch } from 'react-hook-form';
import { FormValue, Type } from '../type';
import { usePriceByPairIndex } from '@/store/selector';
import { usePairs } from '@/store/pairs';
import { calculateTPSLV2 } from './calculateTPSLV2';
import { useMemo } from 'react';

export function usePreviewTpSl() {
    const { control } = useFormContext<FormValue>();

    const [amount, pairIndex, type, leverage, tp, sl] = useWatch({
        control,
        name: ['amount', 'pairIndex', 'type', 'leverage', 'tp', 'sl'],
    });

    const { price } = usePriceByPairIndex(pairIndex);
    const decimalsToShow = usePairs(
        (state) => state.data.find((p) => p.pairIndex === Number(pairIndex))?.decimalsToShow ?? 6
    );

    return useMemo(() => {
        const result = calculateTPSLV2({
            entryPrice: Number(price || 0),
            amount: Number(amount || 0),
            leverage: leverage,
            typeTrade: type === Type.Long ? 'Long' : 'Short',
            decimalsToShow,
            tpPercent: Number(tp) || undefined,
            slPercent: Number(sl) || undefined,
        });

        return {
            positionSize: result.positionSize,
            tpPrice: result.tpPrice,
            slPrice: result.slPrice,
            liqPrice: result.liqPrice,
            tpProfit: result.tpPnL,
            slLoss:result.slPnL,
            takeProfitPercent: result.tpPercent,
            stopLossPercent: result.slPercent,
        };
    }, [price, amount, leverage, type, decimalsToShow, tp, sl]);
}
